(function(){
  if(window.__trHome)return;window.__trHome=true;
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  /* header: fixed bar sits under the scrolling announcement, glass after scroll */
  function initHeader(){
    var bar=$('[data-tr-hdr]');if(!bar)return;var ann=$('.tr-ann');
    function pos(){
      var y=window.pageYOffset||0,off=ann?Math.max(0,ann.offsetHeight-y):0;
      bar.style.top=off+'px';bar.classList.toggle('is-scrolled',y>40);bar.classList.toggle('is-top',y<=40);
    }
    pos();window.addEventListener('scroll',pos,{passive:true});window.addEventListener('resize',pos);
    var b=$('[data-tr-burger]'),p=$('[data-tr-panel]');
    if(b&&p)b.addEventListener('click',function(){var o=p.classList.toggle('is-open');b.setAttribute('aria-expanded',o)});
  }
  function setCount(n){$$('[data-tr-cart-count]').forEach(function(e){e.textContent=n})}
  function refreshCount(){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){})}
  function flash(btn,txt){
    var old=btn.getAttribute('data-label')||btn.textContent;btn.setAttribute('data-label',old);
    btn.textContent=txt;btn.disabled=true;setTimeout(function(){btn.textContent=old;btn.disabled=false},1800);
  }
  function initAtc(){
    document.addEventListener('submit',function(e){
      var f=e.target;if(!f.matches||!f.matches('[data-tr-atc]'))return;
      e.preventDefault();var btn=f.querySelector('button[type=submit]');
      var fd=new FormData(f);
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}}).then(function(r){
        if(!r.ok)throw 0;return r.json()
      }).then(function(){refreshCount();if(btn)flash(btn,'Added ✓');document.dispatchEvent(new CustomEvent('tr:cart-add'))}).catch(function(){f.submit()});
    });
    document.addEventListener('submit',function(e){
      var f=e.target;if(!f.matches||!f.matches('[data-tr-bundle]'))return;
      e.preventDefault();var btn=f.querySelector('button[type=submit]');
      var ids=(f.getAttribute('data-ids')||'').split(',').filter(Boolean).map(function(i){return{id:parseInt(i,10),quantity:1}});
      var code=f.getAttribute('data-code');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:ids})}).then(function(r){
        if(!r.ok)throw 0;return r.json()
      }).then(function(){refreshCount();if(code){window.location.href='/discount/'+encodeURIComponent(code)+'?redirect=/cart'}else if(btn){flash(btn,'Added ✓')}}).catch(function(){window.location.href='/cart'});
    });
  }
  function init(){initHeader();initAtc()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
